import React from "react";
import { Link } from "react-router-dom";

export function AuthShell({ title, eyebrow, children, footer }) {
  return (
    <div className="min-h-screen bg-[#080808] text-[#F4F4F0] flex flex-col">
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" className="flex flex-col leading-none" data-testid="auth-brand-link">
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-semibold">
              Young Black Man Incorporated
            </span>
            <span className="font-display text-xl font-extrabold tracking-tight mt-0.5">Studios</span>
          </Link>
          <Link to="/" className="text-sm text-[#A0A0A0] hover:text-[#F4F4F0] transition-colors" data-testid="auth-back-link">
            ← Back to site
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          {eyebrow && (
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#D4AF37] mb-4">{eyebrow}</p>
          )}
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter text-[#F4F4F0] mb-3 leading-[1.05]">
            {title}
          </h1>
          <div className="h-px w-12 bg-[#D4AF37] mb-8" />
          {children}
          {footer && <div className="mt-8 text-sm text-[#A0A0A0]">{footer}</div>}
        </div>
      </main>
    </div>
  );
}

export function FormInput({ label, type = "text", value, onChange, placeholder, autoComplete, testId, required }) {
  return (
    <label className="block mb-5">
      <span className="block text-xs font-bold uppercase tracking-[0.18em] text-[#A0A0A0] mb-2">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        data-testid={testId}
        className="w-full bg-[#121212] border border-[#2A2A2A] focus:border-[#D4AF37] outline-none px-4 py-3.5 text-[#F4F4F0] placeholder-[#5A5A5A] transition-colors"
      />
    </label>
  );
}

export function PrimaryButton({ children, disabled, type = "submit", onClick, testId }) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
      className="w-full bg-[#D4AF37] text-[#080808] font-bold py-3.5 hover:bg-[#F0C84B] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {children}
    </button>
  );
}

export function ErrorBanner({ message, testId = "form-error" }) {
  if (!message) return null;
  return (
    <div data-testid={testId} className="mb-5 px-4 py-3 border border-red-500/40 bg-red-500/10 text-red-300 text-sm">
      {message}
    </div>
  );
}

export function SuccessBanner({ message, testId = "form-success" }) {
  if (!message) return null;
  return (
    <div data-testid={testId} className="mb-5 px-4 py-3 border border-[#D4AF37]/40 bg-[#D4AF37]/10 text-[#D4AF37] text-sm">
      {message}
    </div>
  );
}
